import { Injectable } from '@angular/core';
import { Setor } from '../models/setor';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class SetorService {

  constructor(
    private http: HttpClient
  ) { }

  salvar(setor: Setor) {
    return this.http.post(globals.apiUrl + '/api/Setor/Salvar', setor);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Setor/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  consultarPorIdSetor(idSetor) {
    return this.http.get<any>(globals.apiUrl + '/api/Setor/Buscar',
      { params: new HttpParams().set('id', idSetor) });
  }

  consultarSetores() {
    return this.http.get<Setor[]>(globals.apiUrl + '/api/Setor/Lista');
  }

  consultarComPaginacao(descri, paginaAtual, qtdRegistros, campoOrdenacao, asc_desc) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', asc_desc)
      .set('descri', descri ? descri : '');

    return this.http.get<any>(globals.apiUrl + '/api/Setor/ListaPag',
      {
        params: parametros
      });
  }
}
